import { AppBar, Toolbar, IconButton, Box, Button, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { KeyboardArrowLeft } from "@mui/icons-material";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import NightsStayOutlinedIcon from "@mui/icons-material/NightsStayOutlined";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser } from "../pages/auth/authSlice";
import { setColorMode, selectColorMode } from "../../theme/themeSlice";
import { useGetChatConversationsQuery } from "../../app/communicationApiSlice";

function CommunicationHeader({ drawerWidth, handleDrawerToggle }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const colorMode = useSelector(selectColorMode);
  const { data: convsData } = useGetChatConversationsQuery();
  const totalUnread = (convsData?.conversations || []).reduce(
    (acc, c) => acc + (c.unread_count || 0),
    0
  );

  const modeSequence = ["system", "light", "dark"];
  const handleModeToggle = () => {
    const next = modeSequence[(modeSequence.indexOf(colorMode) + 1) % modeSequence.length];
    dispatch(setColorMode(next));
  };

  const modeIcon =
    colorMode === "light" ? (
      <WbSunnyOutlinedIcon fontSize="small" />
    ) : colorMode === "dark" ? (
      <NightsStayOutlinedIcon fontSize="small" />
    ) : (
      <SettingsBrightnessIcon fontSize="small" />
    );

  const modeLabel =
    colorMode === "light"
      ? "Light mode"
      : colorMode === "dark"
      ? "Dark mode"
      : "System default";

  const userRoles = user?.roles?.map((r) => r?.role?.name).filter(Boolean) || [];
  const isParent = userRoles.includes("parent");
  const isTeacher = userRoles.includes("teacher");

  const handleExit = () => {
    if (isParent && !isTeacher) {
      navigate("/parent");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={(theme) => ({
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        boxShadow: "none",
        backgroundColor: theme.palette.mode === "dark" ? "#1e1e1e" : "#f1f1f1",
        borderBottom: `1px solid ${theme.palette.mode === "dark" ? "#333" : "#e7e7e7"}`,
      })}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon sx={{ color: "primary.safeOnLight" }} />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Tooltip title={modeLabel}>
          <IconButton
            onClick={handleModeToggle}
            sx={{ color: "primary.safeOnLight", ml: 1 }}
          >
            {modeIcon}
          </IconButton>
        </Tooltip>

        <Button
          endIcon={<KeyboardArrowLeft />}
          onClick={handleExit}
          sx={{
            textTransform: "capitalize",
            color: "primary.safeOnLight",
            fontSize: "0.9rem",
            fontWeight: 600,
            "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" },
          }}
        >
          Exit
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default CommunicationHeader;
